import React, { lazy, Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import store from './store/index';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Progress } from './components/ui/progress'; // Import the Progress component from shadcn/ui

// Custom hook to track loading progress
const useLoadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleProgress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        setProgress(percentComplete);
      }
    };

    // Simulate real loading progress (for demonstration purposes)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 10;
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return progress;
};

// Lazy load the App component
const App = lazy(() => import('./App'));

// Custom Loading Component
const LoadingScreen = () => {
  const progress = useLoadingProgress(); // Get the loading progress

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white space-y-4">
      {/* Progress Bar */}
      <div className="w-64">
        <Progress value={progress} className="h-2" />
      </div>
      {/* Preparing Text */}
      <p className="text-gray-700 text-lg font-semibold">Preparing merchant</p>
    </div>
  );
};

// Render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback={<LoadingScreen />}>
        <App />
        <Toaster
          toastOptions={{
            position: 'top-right',
            style: {
              background: 'white',
              color: 'black',
            },
          }}
        />
      </Suspense>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();